import * as React from 'react';
import { useState } from 'react';
import { Button } from 'antd';
import AudioPlayer from '../MessageBubble/AudioPlayer';
import AIIcon from '../AIIcon';
import { MessageContent } from '../message_content/MessageContent';

require('./AudioNoteContent.less');

interface AudioNoteContentProps {
	/** A note whose `audio` field holds the clip URL. */
	note: any;
	/** The sender's own message — drives the player's colour preset and the mention backdrop. */
	isOwnMessage?: boolean;
	/** Overrides the player preset; surfaces outside the chat bubble pass 'default'. */
	playerType?: 'message' | 'ownmessage' | 'default';
}

/**
 * A voice note: the waveform player plus its transcription toggle and AI footnotes. Shared by the
 * chat bubble and the notes Media tab so a clip behaves identically in both.
 */
const AudioNoteContent: React.FC<AudioNoteContentProps> = ({
	note,
	isOwnMessage = false,
	playerType,
}) => {
	const [showTranscription, setShowTranscription] = useState(false);

	const toggleTranscription = () => setShowTranscription(!showTranscription);

	const hasTranscription = !!(note.text || (note.elements && note.elements.length > 0));

	return (
		<>
			<AudioPlayer src={note.audio} isOwnMessage={isOwnMessage} type={playerType} />
			{hasTranscription ? (
				<>
					{showTranscription ? (
						<div
							style={{
								fontSize: 16,
								whiteSpace: 'pre-wrap',
								wordBreak: 'break-word',
								marginTop: 8,
							}}
						>
							<MessageContent note={note} isOwnMessage={isOwnMessage} />
						</div>
					) : null}
					<div style={{ marginTop: 8 }}>
						<Button type="link" onClick={toggleTranscription} className="transcription-button">
							{showTranscription ? 'Hide transcription' : 'Show transcription'}
						</Button>
					</div>
				</>
			) : null}
			{note.isAudioTranslated ? (
				<div className="FootnoteRegular extraTextBottom flex items-center gap-1 text-character-secondary">
					<AIIcon className={` ${isOwnMessage ? 'fill-white' : 'fill-character-secondary'}`} />{' '}
					<span> Audio translated.</span>
				</div>
			) : null}
			{note.isAudioTranscriptionError ? (
				<div className="FootnoteRegular extraTextBottom text-character-secondary">
					Transcription unavailable.
				</div>
			) : null}
		</>
	);
};

export default AudioNoteContent;
